import API from '../../../../../services/api';

export const API_TARIFAS = {
    getTarifas: async () => {
        return await API.get('/tarifas').then(res => res.data);
    },
    newTarifa: async (tarifa) => {
        return API.post('/tarifas', tarifa).then(res => res.data);
    },
    updateTarifa: async (tarifa) => {
        return API.put('/tarifas/' + tarifa.id, tarifa).then(res => res.data);
    },
    deleteTarifa: async (idTarifa) => {
        return API.delete('/tarifas/' + idTarifa).then(res => res.data);
    }
}

export const API_TARIFAS_VALORES = {
    newTarifaValor: async (valor) => {
        return API.post('/tarifas-valores', valor).then(res => res.data);
    },
    updateTarifaValor: async (valor) => {
        return API.put('/tarifas-valores/' + valor.id, valor).then(res => res.data);
    },
    deleteTarifaValor: async (idValor) => {
        return API.delete('/tarifas-valores/' + idValor).then(res => res.data);
    }
}